import React, { Component } from 'react';

import './NavItem.css';

class NavItem extends Component {

    isSelected() {
        return this.props.title === this.props.selectedItem
    }

    render() {
        return (
            <div className="admin-nav-item-container flex alignCenter" onClick={this.props.onClick.bind(null, this.props.title)}>
                <div className="flex centerBoth">
                    <img className="admin-nav-item-img"
                         src={this.isSelected() ? this.props.selectedIcon : this.props.icon} alt={"nav icon " + this.props.title} />
                </div>
                <div className={"flex centerBoth lato admin-nav-item-title" + (this.isSelected() ? " admin-nav-item-title-selected" : "")}>
                    {this.props.title}
                </div>
            </div>
        )
    }

}

export default NavItem;


// WEBPACK FOOTER //
// ./src/components/admin-nav/NavItem.js